export const QA_NAME_ADDRESS_SELECT_DROPDOWN_LIST_FOOTER_SHOW_MAP_BTN =
  'showMap'
